import React from 'react';
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';

export const ChannelCardSkeleton = () => (
    <Card
        variant="outlined"
        sx={{
            height: '100%',
            overflow: 'hidden',
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: 160,
                overflow: 'hidden',
            }}
        >
            <Skeleton
                variant="rectangular"
                sx={{ width: '100%', height: '100%', transform: 'none' }}
            />
            <Stack
                direction="row"
                sx={{
                    gap: 1,
                    position: 'absolute',
                    top: 16,
                    left: 16,
                    right: 16,
                    justifyContent: 'space-between',
                }}
            >
                <Skeleton variant="rounded" width={68} height={24} />
                <Skeleton variant="rounded" width={88} height={24} />
            </Stack>
        </Box>
        <CardContent
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}
        >
            <Skeleton
                variant="text"
                sx={{ fontSize: '1.25rem', width: '70%' }}
            />
            <Skeleton
                variant="text"
                sx={{ fontSize: '0.875rem', width: '45%' }}
            />
        </CardContent>
    </Card>
);

export default ChannelCardSkeleton;
